
import { baseApi } from './baseApi'

export const conversationsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_conversations: builder.query<any, any>({
      query: (id) => ({
        url: `/conversations/${id}/`,
      }),
      providesTags: ['conversations'],
    }),
    GET_conversationMessages: builder.query<any, any>({
        query: (id) => ({
          url: `/conversation-messages/${id}/`,
        }),
        providesTags: ['conversations'],
      }),
    POST_conversation: builder.mutation<any, any>({
        query: ({ id, body }) => ({
          url: `/conversation-messages/${id}/`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['conversations'],
      }),
  }),
})

export const { useGET_conversationsQuery, useGET_conversationMessagesQuery, usePOST_conversationMutation, } = conversationsAPI
